<template>
  <div v-for="dependency in dependencies" class="mb-3">
    <planning-element-view :el="displayableEl(dependency.targetEl)" disable-mini-element disable-styling>
      <template #hover-menu>
        <div class="element-menu" :style="elementMenuPosition(dependency.targetEl, successors)" @click.stop>
          <v-btn :title="$t('DEPENDENCIES.EDIT_THIS_EL')" icon size="x-small" variant="outlined" @click="$emit('setMainEl', dependency.targetEl)">
            <v-icon size="large">far fa-link</v-icon>
          </v-btn>
          <v-btn :title="$t('DEPENDENCIES.REMOVE')" icon size="x-small" variant="outlined" @click="$emit('delete', dependency.targetEl)">
            <v-icon size="large" color="errorred">far fa-times</v-icon>
          </v-btn>
        </div>
      </template>

      <template #footer>
        <div v-if="canEditDependencyType" class="users-bar d-flex align-center px-1 nobr small-input small">
          <btn-toggle-field v-model="dependency.type" :items="dependencyTypeItems" mandatory="force"
                            :btn-props="{ size: 'small', class: 'px-2', style: 'min-width: 0' }" style="height: 24px"
                            @update:model-value="$emit('update', dependency)">
          </btn-toggle-field>
        </div>
        <div class="users-bar d-flex align-center px-1 nobr small-input">
          <label :for="`${delayIdPrefix}${dependency.targetEl.id}`">{{ $t('DEPENDENCIES.DELAY') }} :</label>
          <div class="input-autosize-wrapper" style="height: auto">
            <div class="input-autosize-invisible-text px-1" style="min-width: 40px">{{ dependency.delay || 0 }}</div>
            <input v-model="dependency.delay" :id="`${delayIdPrefix}${dependency.targetEl.id}`" type="number" placeholder="0" class="px-1"
                   @change="$emit('update', dependency)">
          </div>
          {{ $t('GLOBAL.DAYS', dependency.delay) }}
        </div>
      </template>
    </planning-element-view>
  </div>
</template>

<script>
  import useUsersAccessRightStore from '@/stores/users/accessRight';
  import PlanningElementView from '@/components/Planning/PlanningElementView.vue';

  export default {
    components: {
      PlanningElementView,
    },
    props: {
      dependencies: { type: Array, required: true },
      successors: { type: Boolean, default: false },
    },
    emits: ['setMainEl', 'delete', 'update'],
    data() {
      return {
        dependencyTypeItems: [
          { title: this.$t('DEPENDENCIES.FS'), tooltip: this.$t('DEPENDENCIES.FS_DESC'), value: null },
          { title: this.$t('DEPENDENCIES.SS'), tooltip: this.$t('DEPENDENCIES.SS_DESC'), value: 'SS' },
          { title: this.$t('DEPENDENCIES.FF'), tooltip: this.$t('DEPENDENCIES.FF_DESC'), value: 'FF' },
        ],
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      delayIdPrefix() {
        return this.successors ? 'delay-succ-' : 'delay-pred-';
      },
      canEditDependencyType() {
        return this.usersAccessRightStore.config.dependencyTypes;
      },
    },
    methods: {
      displayableEl(el) {
        const displayableEl = angular.copy(el);
        displayableEl.ytextposition = 20;
        displayableEl.setConfig({ 'show-progress': false }); // hide all
        if (displayableEl.getIsLocked()) displayableEl.setConfig({ 'show-dates': true, 'show-date': true, 'show-progress': false });
        return displayableEl;
      },
      elementMenuPosition(el, isSuccessor) {
        return {
          left: isSuccessor ? null : '100%',
          right: isSuccessor ? '100%' : null,
          top: 0,
          'text-align': ! isSuccessor ? 'left' : 'right',
          'margin-top': el.isType('macro', 'task') && el.hasIcon() ? '22px' : '0',
        };
      },
    },
  };
</script>
